import React from 'react'

const Teamate = (props) => {
  return (
    <div className="group h-full">
      <div className="relative bg-white rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 p-4 sm:p-6 h-full flex flex-col">
        {/* Badge grade */}
        {props.grade && (
          <div className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-gradient-to-r from-primary to-red-600 text-white text-xs font-semibold px-2 sm:px-3 py-1 rounded-full">
            {props.grade}
          </div>
        )}
        
        {/* Photo avec effet moderne */}
        <div className="relative mb-4 sm:mb-6 flex-shrink-0">
          <div className="relative overflow-hidden rounded-full w-24 h-24 sm:w-32 sm:h-32 lg:w-40 lg:h-40 mx-auto">
            <img 
              alt={props.name} 
              src={props.img} 
              className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-500"
            />
          </div>
        </div>
        
        {/* Informations */}
        <div className="text-center space-y-2 sm:space-y-3 flex-grow flex flex-col">
          <h3 className="text-sm sm:text-lg lg:text-xl font-bold text-gray-900 group-hover:text-primary transition-colors duration-300 flex-shrink-0">
            {props.name}
          </h3>
          
          <div className="space-y-1 sm:space-y-2 flex-shrink-0">
            <p className="text-xs sm:text-sm font-semibold text-primary bg-red-50 px-2 sm:px-3 py-1 rounded-full inline-block">
              {props.title}
            </p>
          </div>
          
          <p className="text-xs sm:text-sm text-gray-600 leading-relaxed flex-grow">
            {props.desc}
          </p>
        </div>
        
        {/* Icône décorative */}
        <div className="absolute bottom-0 right-0 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-gradient-to-br from-primary/5 to-red-100/10 rounded-tl-full"></div>
      </div>
    </div>
  )
}

export default Teamate